import LetsAdminTemplate from '../router/template/LetsAdminTemplate.vue'
import { h } from 'vue'

export default [
  {
    path: '/',
    component: LetsAdminTemplate,
    children:[
      {
        path: '',
        name: 'Home',
        component: () => import('./index.vue'),
        meta:{
        }
      }
    ]
  },
  {
    path: '/Auth',
    component: () => import('vue-router').then(m => m.RouterView),
    meta: { notLogged: true },
    children: [
      {
        path: 'login',
        name: 'Login',
        component: () => import('./Auth/PgAuth.vue'),
      }
    ]
  },
  {
    path: '/Chatroom/:studentNo?',
    component: () => import('vue-router').then(m => m.RouterView),
    children: [
      {
        path: '',
        name: 'Chatroom',
        component: () => import('./Chatroom/PgChatroom.vue'),
      }
    ]
  },
  {
    path: '/PendingSchedule',
    component: () => import('vue-router').then(m => m.RouterView),
    children: [
      {
        path: '',
        name: 'PendingSchedule',
        component: () => import('./C20201/comp/PendingSchedule.vue'),
      }
    ]
  },
  {
    path: '/MeetingLog',
    component: () => import('vue-router').then(m => m.RouterView),
    children: [
      {
        path: '',
        name: 'MeetingLog',
        component: () => import('./C40501/comp/MeetingLog.vue'),
      }
    ]
  },
  {
    path: '/C00101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C00101',
        component: ()=> import('./C00101/PgC00101.vue'),
      }
    ]
  },
  {
    path: '/C00102',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C00102',
        component: () => import('./C00102/PgC00102.vue'),
      }
    ]
  },
  {
    path: '/C00103',
    component: LetsAdminTemplate,
    children: [
      {
        path: 'view/:support_no?',
        name: 'C00103',
        component: () => import('./C00103/PgC00103View.vue'),
        meta: {
        }
      }
    ]
  },
  {
    path: '/C10101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C10101Browse',
        component: () => import('./C10101/PgC10101Browse.vue'),
        meta:{
        }
      },
      {
        path: ':teacher_id?/edit',
        name: 'C10101Edit',
        component: () => import('./C10101/PgC10101Edit.vue'),
        meta:{
        }
      },
      {
        path: 'add',
        name: 'C10101Add',
        component: () => import('./C10101/PgC10101Add.vue'),
        meta:{
        }
      },
    ]
  },
  {
    path: '/C10201',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C10201',
        component: () => import('./C10201/PgC10201.vue'),
      },
      {
        path: 'teacher/:teacher_no',
        name: 'C10201Teacher',
        component: () => import('./C10201/PgC10201.vue'),
      }
    ]
  },
  {
    path: '/C10301',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C10301',
        component: () => import('./C10301/PgC10301.vue'),
        meta:{
        }
      }
    ]
  },
  {
    path: '/C10401',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C10401',
        component: () => import('./C10401/PgC10401.vue'),
        meta:{
        }
      }
    ]
  },
  {
    path: '/C10402',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C10402',
        component: () => import('./C10402/PgC10402.vue'),
        meta:{
        }
      }
    ]
  },
  {
    path: '/C20101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C20101Browse',
        component: () => import('./C20101/PgC20101Browse.vue'),
        meta:{
        }
      },
      {
        path: ':student_id?/edit',
        name: 'C20101Edit',
        component: () => import('./C20101/PgC20101Edit.vue'),
        meta:{
        }
      },
      {
        path: 'add',
        name: 'C20101Add',
        component: () => import('./C20101/PgC20101Add.vue'),
        meta:{
        }
      }
    ]
  },
  {
    path: '/C20201',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C20201Browse',
        component: () => import('./C20201/PgC20201Browse.vue'),
        meta:{
        }
      },
      {
        path: 'edit/:curriculum_id?',
        name: 'C20201Edit',
        component: () => import('./C20201/PgC20201Edit.vue'),
        meta:{
        }
      },
      {
        path: 'add',
        name: 'C20201Add',
        component: () => import('./C20201/PgC20201Add.vue'),
        meta:{
        }
      }
    ]
  },
  {
    path: '/C20301',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C20301Browse',
        component: () => import('./C20301/PgC20301Browse.vue'),
        meta:{
        }
      },
    ]
  },
  {
    path: '/C30101',
    component: LetsAdminTemplate,
    children: [
      {
        path: 'old',
        name: 'C30101Old',
        component: () => import('./C30101/PgC30101.vue'),
        meta:{
        }
      },
      {
        path: '',
        name: 'C30101',
        component: () => import('./C30101V2/PgC30101.vue'),
        meta:{
        }
      },
      {
        path: 'studentold',
        name: 'C30101StudentOld',
        component: () => import('./C30101Student/PgC30101.vue'),
        meta:{
        }
      },
      {
        path: 'student',
        name: 'C30101Student',
        component: () => import('./C30101V2/PgC30101StudentInit.vue'),
        meta:{
        }
      },
      {
        path: 'studentEntryType2',
        name: 'C30101StudentEntryType2',
        component: () => import('./C30101V2/PgC30101StudentEntryType2.vue'),
        meta:{
        }
      },
      {
        path: 'studentEntryType3',
        name: 'C30101StudentEntryType3',
        component: () => import('./C30101V2/PgC30101StudentEntryType3.vue'),
        meta:{
        }
      },
      {
        path: 'studentEntryType4',
        name: 'C30101StudentEntryType4',
        component: () => import('./C30101V2/PgC30101StudentEntryType4.vue'),
        meta:{
        }
      }
    ]
  },
  {
    path: '/C30201',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C30201',
        component: () => import('./C30201/PgC30201.vue'),
        meta:{
        }
      },
    ]
  },
  {
    path: '/C40101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C40101',
        component: () => import('./C40101/PgC40101.vue'),
        meta:{
          showFooter: false
        }
      },
    ]
  },
  {
    path: '/C40201',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C40201',
        component: () => import('./C40201/PgC40201.vue'),
      },
    ]
  },
  {
    path: '/C40401',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C40401Browse',
        component: () => import('./C40401/PgC40401Browse.vue'),
      }
    ]
  },
  {
    path: '/C40411',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C40411Browse',
        component: () => import('./C40411/PgC40411Browse.vue'),
      }
    ]
  },
  {
    path: '/C40501',
    component: LetsAdminTemplate,
    name: 'C40501',
    redirect: { name: 'C40501Browse' },
    children: [
      {
        path: '',
        name: 'C40501Browse',
        component: () => import('./C40501/PgC40501Browse.vue'),
      }
    ]
  },
  {
    path: '/C40701',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C40701Browse',
        component: () => import('./C40701/PgC40701Browse.vue'),
      }
    ]
  },
  {
    path: '/C50101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C50101Browse',
        component: () => import('./C50101/PgC50101Browse.vue'),
      },
      {
        path: 'teacher',
        name: 'C50101TeacherBrowse',
        component: () => import('./C50101/PgC50101Browse.vue'),
      }
    ]
  },
  {
    path: '/C50102',
    component: LetsAdminTemplate,
    children: [
      {
        path: 'pastReport/:schedule_no?',
        name: 'C50102PastReport',
        component: () => import('./C50102/comp/C50102PastReport.vue'),
      },
      {
        path: ':schedule_no',
        name: 'C50102',
        component: () => import('./C50102/PgC50102.vue'),
      }
    ]
  },
  {
    path: '/C50103',
    component: LetsAdminTemplate,
    children: [
      {
        path: ':schedule_no?',
        name: 'C50103',
        component: () => import('./C50103/PgC50103.vue'),
      }
    ]
  },
  {
    path: '/C11101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C11101',
        component: () => import('./C11101/PgC11101.vue'),
      }
    ]
  },
  {
    path: '/C11201',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C11201',
        component: () => import('./C11201/PgC11201.vue'),
      }
    ]
  },
  {
    path: '/C21101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C21101',
        component: () => import('./C21101/PgC21101.vue'),
      }
    ]
  },
  {
    path: '/C21201',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C21201',
        component: () => import('./C21201/PgC21201.vue'),
      }
    ]
  },
  {
    path: '/B00101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'B00101',
        component: { render: () => h('div', '作成中') },
      }
    ]
  },
  {
    path: '/B00201',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'B00201',
        component: { render: () => h('div', '作成中') },
      }
    ]
  },
  {
    path: '/B00301',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'B00301',
        component: { render: () => h('div', '作成中') },
      }
    ]
  },
  {
    path: '/M00101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M00101',
        component: () => import('./M00101/PgM00101Browse.vue'),
      },
      {
        path: 'add',
        name: 'M00101Add',
        component: () => import('./M00101/PgM00101Add.vue'),
        meta:{
        }
      },
      {
        path: 'edit/:notice_no',
        name: 'M00101Edit',
        component: () => import('./M00101/PgM00101Edit.vue'),
        meta:{
        }
      },
    ]
  },
  {
    path: '/M00201',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M00201',
        component: () => import('./M00201/PgM00201.vue'),
      },
    ]
  },
  {
    path: '/M00501',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M00501Browse',
        component: () => import('./M00501/PgM00501Browse.vue'),
      }
    ]
  },
  {
    path: '/M20101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M20101Browse',
        component: () => import('./M20101/PgM20101Browse.vue'),
        meta:{
        }
      },
      {
        path: 'add',
        name: 'M20101Add',
        component: () => import('./M20101/PgM20101Add.vue'),
        meta:{
        }
      },
      {
        path: 'edit/:center_no',
        name: 'M20101Edit',
        component: () => import('./M20101/PgM20101Edit.vue'),
        meta:{
        }
      }
    ]
  },
  {
    path: '/M20201',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M20201Browse',
        component: () => import('./M20201/PgM20201Browse.vue'),
        meta: {
        }
      },
      {
        path: 'add',
        name: 'M20201Add',
        component: () => import('./M20201/PgM20201Add.vue'),
        meta:{
        }
      },
      {
        path: ':classroom_no?/edit',
        name: 'M20201Edit',
        component: () => import('./M20201/PgM20201Edit.vue'),
        meta:{
        }
      },
    ]
  },
  {
    path: '/M20301',
    name: 'M20301',
    component: LetsAdminTemplate,
    redirect: { name: 'M20301Browse' },
    children: [
      {
        path: '',
        name: 'M20301Browse',
        component: () => import('./M20301/PgM20301Browse.vue'),
        meta: {
        }
      },
      {
        path: 'add/:_course_type',
        name: 'M20301Add',
        component: () => import('./M20301/PgM20301Add.vue'),
        children:[
          {
            path: 'M1005',
            name: 'M20301AddM1005',
            component: () => import('./M20301/comp/M1005Edit.vue'),
            meta:{
            }
          },
          {
            path: 'M1010',
            name: 'M20301AddM1010',
            component: () => import('./M20301/comp/M1010Edit.vue'),
            meta:{
            }
          }
        ]
      },
      {
        path: ':id/edit/:_course_type',
        name: 'M20301Edit',
        component: () => import('./M20301/PgM20301Edit.vue'),
        children:[
          {
            path: 'M1005',
            name: 'M20301EditM1005',
            component: () => import('./M20301/comp/M1005Edit.vue'),
            meta:{
            }
          },
          {
            path: 'M1010',
            name: 'M20301EditM1010',
            component: () => import('./M20301/comp/M1010Edit.vue'),
            meta:{
            }
          }
        ]
      },
    ]
  },
  {
    path: '/M20401',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M20401Browse',
        component: () => import('./M20401/PgM20401Browse.vue'),
        meta: {
        }
      },
      {
        path: 'add',
        name: 'M20401Add',
        component: () => import('./M20401/PgM20401Add.vue'),
        meta:{
        }
      },
      {
        path: ':subject_no?/edit',
        name: 'M20401Edit',
        component: () => import('./M20401/PgM20401Edit.vue'),
        meta:{
        }
      },
    ]
  },
  {
    path: '/M20601',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'PgM20601BatchEdit',
        component: () => import('./M20601/PgM20601BatchEdit.vue'),
        meta: {
        }
      },
    ]
  },
  {
    path: '/M20701',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M20701Browse',
        component: () => import('./M20701/PgM20701Browse.vue'),
        meta: {
        }
      },
      // {
      //   path: 'add',
      //   name: 'M20701Add',
      //   component: () => import('./M20701/PgM20701Add.vue'),
      //   meta:{
      //   }
      // },
      {
        path: ':id/edit',
        name: 'M20701Edit',
        component: () => import('./M20701/PgM20701Edit.vue'),
        meta:{
        }
      },
    ]
  },
  {
    path: '/M20801',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M20801Browse',
        component: () => import('./M20801/PgM20801Browse.vue'),
        meta: {
        }
      },
      {
        path: 'add',
        name: 'M20801Add',
        component: () => import('./M20801/PgM20801Add.vue'),
        meta:{
        }
      },
      {
        path: 'edit/:seminar_name',
        name: 'M20801Edit',
        component: () => import('./M20801/PgM20801Edit.vue'),
        meta:{
        }
      },
    ]
  },
  {
    path: '/M20901',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M20901Browse',
        component: () => import('./M20901/PgM20901Browse.vue'),
        meta: {
        }
      },
      {
        path: 'add',
        name: 'M20901Add',
        component: () => import('./M20901/PgM20901Add.vue'),
        meta:{
        }
      },
      {
        path: ':user_no?/edit',
        name: 'M20901Edit',
        component: () => import('./M20901/PgM20901Edit.vue'),
        meta:{
        }
      },
    ]
  },
  {
    path: '/M21001',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M21001Browse',
        component: () => import('./M21001/PgM21001Browse.vue'),
        meta: {
        }
      },
      {
        path: 'edit/:year',
        name: 'M21001BatchEdit',
        component: () => import('./M21001/PgM21001BatchEdit.vue'),
        meta: {
        }
      },
    ]
  },
  {
    path: '/M21101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M21101Browse',
        component: () => import('./M21101/PgM21101Browse.vue'),
        meta: {
        }
      },
      {
        path: 'edit/:support_no',
        name: 'M21101Edit',
        component: () => import('./M21101/PgM21101Edit.vue'),
        meta: {
        }
      },
    ]
  },
   {
    path: "/M21201",
    component: LetsAdminTemplate,
    children: [
      {
        path: "",
        name: "M21201Browse",
        component: () => import("./M21201/PgM21201Browse.vue"),
        meta: {},
      },
      {
        path: "edit/:setting_no/:setting_code",
        name: "M21201Edit",
        component: () => import("./M21201/PgM21201Edit.vue"),
        meta: {},
      },
      {
        path: "add",
        name: "M21201Add",
        component: () => import("./M21201/PgM21201Add.vue"),
        meta: {},
      },
    ],
  },
  {
    path: '/M21301',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M21301Browse',
        component: () => import('./M21301/PgM21301Browse.vue'),
        meta:{
        }
      },
      {
        path: 'add',
        name: 'M21301Add',
        component: () => import('./M21301/PgM21301Add.vue'),
        meta:{
        }
      },
      {
        path: 'edit/:time_limit_no',
        name: 'M21301Edit',
        component: () => import('./M21301/PgM21301Edit.vue'),
        meta:{
        }
      }
    ]
  },
  {
    path: '/M21501',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M21501Browse',
        component: () => import('./M21501/PgM21501Browse.vue'),
        meta:{
        }
      },
      {
        path: 'edit/:school_year_code',
        name: 'M21501Edit',
        component: () => import('./M21501/PgM21501Edit.vue'),
        meta:{
        }
      }
    ]
  },
  {
    path: '/M21601',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M21601Browse',
        component: () => import('./M21601/PgM21601Browse.vue'),
        meta:{
        }
      },
       {
        path: 'add',
        name: 'M21601Add',
        component: () => import('./M21601/PgM21601Add.vue'),
        meta:{
        }
      },
      {
        path: 'edit/:teach_subject_no',
        name: 'M21601Edit',
        component: () => import('./M21601/PgM21601Edit.vue'),
        meta:{
        }
      }
    ]
  },
  {
    path: '/404',
    name: '404',
    component: () => import('./404/404.vue')
  }
]
